const ApplicationName = 'Network Performance Reports'

const Links = Object.freeze({
  viewSites: '/service-performance/sites-services-status/sites',
  viewServices: '/service-performance/sites-services-status/services',
  viewSDWAN: '/service-performance/sdwan',
  applyFilterLink: 'Apply',
  timeRange: 'Time Range',
  siteService: (siteId) => `/service-performance/sites/${siteId}/services`,
  issues: 'Issues',
  degraded: 'Degraded',
  dataUnavailable: 'Data unavailable',
  optimal: 'Optimal',
  notApplicable: 'Not applicable',
  referenceEdit: 'Reference Edit',
  referenceSave: 'Reference Save',
  lengthExceeded: 'Reference Length Exceeded',
  infoIcon: 'User Read Info',
  hoverMapMarker: 'Hover on Map Marker',
  dashboardBreadcrumb: 'Dahsboard Breadcrumb Clicked',
  dataExport: 'Export Button Clicked',
  hideMap: 'Hide map clicked',
  mapTooltip: 'Map tooltip link',
  serviceFilter: 'Service Filter Clicked',
  applyFilter: 'Apply Filter Clicked',
  cancelFilter: 'Cancel Filter Clicked',
  graphToggle: 'Graph Toggle Button Clicked',
  mapToggle: 'Map Toggle Button Clicked for Mobile',
  breadCrumb: 'Bread Crumb Clicked',
  toolMenu: 'Tool Menu Clicked',
  dashboardFAQ: 'FAQ clicked from Dashboard',
  serviceSearch: 'Search by Services',
  siteSearch: 'Search by Location',
  mapMarker: 'Map Marker Clicked',
  veloCloudLink: 'Redirected to VeloCloud Portal',
  raiseIncident: 'Raise New Incident Button Clicked',
  incidentActivity: 'Incident Activity Clicked',
  plannedMaintenance: 'Planned Maintenance Clicked',
  plannedMaintenanceInt: 'Planned Maintenance Clicked - Int',
  viewContactNumber: 'View Contact Number Clicked',
  viewEmailAddress: 'View Email Address Clicked',
  serviceTypeSorting: 'Sorting on Product name clicked',
  productNameSorting: 'Sorting on Product name clicked',
  serviceIdSorting: 'Sorting on Service ID clicked',
  connectionIdSorting: 'Sorting on Connection ID clicked',
  userReferenceSorting: 'Sorting on Your service reference clicked',
  availabilityActivitySorting: 'Sorting on Activity/Availability clicked',
  utilisationSorting: 'Sorting on Utilisation clicked',
  errorsSorting: 'Sorting on Errors clicked',
  locationSorting: 'Sorting on Locations clicked',
  wanAvailabilitySorting: 'Sorting on WAN availability clicked',
  lanAvailabilitySorting: 'Sorting on LAN availability clicked',
  servicesWithPerformanceDataTabLink: 'Services with performance data tab on List of services ',
  SearchClick: 'Search click on List of services',
  SearchEntered: 'Search entered on List of services',
  FAQLink: 'FAQs on List of services',
  paginationLink: 'Pagination on List of services',
  serviceIDInformationModal: 'Service ID information modal on List of services',

  SDWANAccordionClick: 'SDWAN accordion click',
  performanceTabServiceClick: 'Service click',
  SDWANRouterClick: (productName) => `${productName} router click`,
  interfaceClickOnListPage: (productName) => `${productName} Interface click`,
  LTELinkClickOnListPage: (productName) => `${productName} LTE Service click`,

  genericListPageRouterSSOClick: (productName) => `${productName} router SSO click`,
  genericListPageInterfaceSSOClick: (productName) => `${productName} interface SSO click`,

  genericDetailPageSSOClick: (productName) => `${productName} details SSO click`,

  merakiSSOClick: 'SDWANMerakiSSO click', // service without performance tab
  InterfaceLink: 'Interface (any) link',
  LTELink: 'LTE Service (any) link',
  routerLink: 'Router link',

  continueOnModalClickForSSO: 'SSO continue click',
  viewSitesInt: 'Your Services - Int',
  viewServicesInt: 'View All Services - Int',
  hoverMapMarkerInt: 'Hover on Map Marker - Int',
  infoIconInt: 'User Read Info - Int',
  hideMapInt: 'Hide map clicked - Int',
  routerLinkInt: 'Router link - Int',
  editReferenceLink: 'Add/Edit Reference Link on Service List - Int',
  saveReferenceLink: 'Save Reference Link on Service List - Int',
  raiseIncidentInt: 'Raise New Incident Button Clicked - Int',
  dashboardBreadcrumbInt: 'Dashboard Breadcrumb Clicked - Int',
  breadCrumbInt: 'Bread Crumb Clicked - Int',
  downloadAllServiceCSVInt: 'Download All Services In CSV File - Int',
  selectColumnInt: 'Select Column Updated for Services - Int',
  plannedMaintenanceFilterClick: 'Planned Maintenance filter click',
  plannedMaintenanceQuickFilterClick: 'Planned Maintenance quick filter click',
  plannedMaintenanceBannerLinkClick: 'Planned maintenance banner link click',
  downloadOrders: {
    open: 'Download summary opened',
    options: {
      'csv': 'Download summary All locations and products(CSV)',
      'Advanced option': 'Download summary Advanced options selected',
    },
    advanceOptions: {
      'All columns': 'Advanced download summary All columns selected',
      'The columns I have selected': `Advanced download summary The columns selected`,
      'CSV': 'Advanced download summary CSV selected',
      'My search and filtered results only': 'Advanced download summary Search and Filters',
      'closed': 'Advanced download summary Cancel clicked',
      'download': 'Advanced download summary Download clicked',
    },
  },
  networkReportsInt: 'NetworkReports:International',
  iPRouteandDNSInt: 'IPRouteandDNS:International',
  sdwanInt: 'SD-WAN:International',
  merakiSdwanInt: 'Meraki SD-WAN:International',
  ciscoSdwanInt: 'Cisco SD-WAN:International',
  networkReportsIntModalContinueClick: 'NetworkReports:International:Continue',
  anpexInt: 'GID-ANPEX opens in new tab'
})

const Components = Object.freeze({
  applyFilterComponent: 'Services Filter',
  applyTimeRangeComponent: 'Services Time Ranges',
  servicesTabComponent: 'Services',
  sitesTabComponent: 'Sites',
  sitesServiceComponent: 'Sites Services',
  serviceDetailsComponent: 'Service Details',
  sdwanTabComponent: 'SD-WAN',
  dashboardComponent: 'YPS: NI: Dashboard',
  serviceWithPerformanceDataComponent: 'YPS: NI: Performance data tab',
  activeServiceComponent: 'YPS: NI: activeservice tab',
  SDWANRouterDetails: 'YPS: NI: SDWAN router details',
  SDWANInterfaceDetails: 'YPS: NI: SDWAN interface/LTE service details:',
  ServiceDetailsPage: 'YPS: NI: Detail page: ',
  listOfServices: 'List of services',
  ServiceDetailsInt: 'Services: Service details:',
  servicesTabComponentInt: 'Services',
  serviceDetailsComponentInt: 'Service Details',
  genericThing: 'YPS: NI:',
  routeManagementComponentInt: 'Route Management Page',
  dnsManagementComponentInt: 'DNS Management Page',
  routeAddPrefixComponentInt: 'Add Prefix Page',
  npReportComponentLinkInt: 'Network Performance Reports:',
  routeManagementSuccessComponentInt: 'Route Management Success Page',
  yourServicesComponent: 'YourServices',
  serviceTilePageInt: 'SSOFeature:ServiceTile',
  serviceDetailPageInt: 'SSOFeature:ServiceDetail',
  requestPageInt: 'SSOFeature:Request',
  yourServicesPageInt: 'SSOFeature:YourServices',
  routeAddDnsComponentInt: 'Add DNS Record',
})

export { ApplicationName, Links, Components }
